import React from 'react';
import { useUser } from '../../hooks/useUser';
import { useQuery } from 'wasp/client/operations';
import { getUserProfile, getUsageStatus } from 'wasp/client/operations';
import { TasteProfileOnboardingFlow } from '../components/onboarding/TasteProfileOnboardingFlow';
import { EnhancedKitchenProfilePage } from '../components/profile/EnhancedKitchenProfilePage';
// AppFrame removed: route-level layout wraps pages
import { useNavigate } from 'react-router-dom';
import { MealPlanErrorBoundary } from '../../components/MealPlanErrorBoundary'
import { AiErrorBoundary } from '../../components/AiErrorBoundary'
import { mapToUITier } from '../../types/subscription';

export function ProfilePage() {
  const { user, isAuthenticated, needsOnboarding } = useUser();
  const { data: userProfile } = useQuery(getUserProfile, {}, { enabled: isAuthenticated });
  const { data: usageStatus } = useQuery(getUsageStatus, {}, { enabled: isAuthenticated });
  const navigate = useNavigate();

  const handleOnboardingComplete = () => {
    // Navigate to dashboard after onboarding completion
    navigate('/');
  };

  const getUserDisplayName = () => {
    if (user?.displayName) return user.displayName;
    if (user?.firstName) return user.firstName;
    if (user?.email) return user.email.split('@')[0];
    return 'Chef';
  };

  const profileProps = {
    userName: getUserDisplayName(),
    userEmail: user?.email || '',
    currentTier: mapToUITier((user?.subscriptionTier || 'demo') as any),
    isEmailVerified: user?.emailVerified || false,
    authProvider: user?.authProvider || 'email',
    onClose: () => navigate(-1) // Navigate back to previous page
  };

  return (
      <MealPlanErrorBoundary>
        <AiErrorBoundary>
           {needsOnboarding ? (
             <TasteProfileOnboardingFlow onComplete={handleOnboardingComplete} />
           ) : (
             <EnhancedKitchenProfilePage {...profileProps} />
           )}
        </AiErrorBoundary>
      </MealPlanErrorBoundary>
  );
}
